import { useEffect, useState } from "react";
import { getUserAgentRegex } from "browserslist-useragent-regexp";
import {
  BodyText,
  Modal,
  ModalContent,
  ModalRoot,
} from "@utilitywarehouse/hearth-react";

import { browserslist } from "../../package.json";
import { env } from "../env";

const extractBrowserslist = (): string[] => {
  return env.isProductionHost
    ? browserslist.production
    : browserslist.development;
};

export const isBrowserSupported = () => {
  const browsers = extractBrowserslist();
  const supportedBrowsers = getUserAgentRegex({
    browsers: browsers,
    allowHigherVersions: true,
  });

  return supportedBrowsers.test(navigator.userAgent);
};

const UnsupportedBrowser: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [supported, setSupported] = useState(true);

  const handleClose = () => setOpen(false);

  useEffect(() => {
    const supported = isBrowserSupported();
    setOpen(!supported);
    setSupported(supported);
  }, []);

  if (supported) {
    return null;
  }

  return (
    <ModalRoot open={open} onOpenChange={handleClose}>
      <Modal heading="Unsupported Browser Detected">
        <ModalContent>
          <BodyText paragraphSpacing>
            It looks like you're using a web browser that may not be fully
            compatible with this webpage. While you can continue, please be
            aware that certain features might not work as expected.
          </BodyText>
          <BodyText paragraphSpacing>
            For the best experience, we recommend upgrading your browser to the
            latest version.
          </BodyText>
        </ModalContent>
      </Modal>
    </ModalRoot>
  );
};

export default UnsupportedBrowser;
